import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private readonly http: HttpClient) {}

  sendProofOfPayment$(paymentHash: string): Observable<void> {
    return this.http.post<void>(`/api/payment/send-proof`, { paymentHash });
  }
}
